"use client";

import { usePostHog } from "posthog-js/react";

import { Button } from "@soonlist/ui/button";
import {
  ANALYTICS_EVENTS,
  ANALYTICS_PROPS,
  PUBLIC_LIST_CTA,
} from "@soonlist/validators";

import { createOneLink } from "~/lib/urlScheme";

export function SubscribeCTA({
  username,
  firstName,
  source,
}: {
  username: string;
  firstName: string;
  source: "event_page" | "list_page";
}) {
  const posthog = usePostHog();
  const getAppUrl = createOneLink({
    deepLinkValue: "follow",
    deepLinkSub1: username,
    campaign: "public_list_follow",
  });

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-white/20 bg-interactive-3/70 shadow-[0_-1px_0_0_rgba(255,255,255,0.5)_inset] backdrop-blur-xl backdrop-saturate-150">
      <div
        className="mx-auto flex w-full max-w-2xl items-center justify-between gap-4 px-6 pt-3 lg:px-8"
        style={{
          paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))",
        }}
      >
        <span className="text-base font-bold text-interactive-1 sm:text-lg">
          <span className="sm:hidden">See more from {firstName}</span>
          <span className="hidden sm:inline">
            See what {firstName} captures next
          </span>
        </span>
        <Button
          onClick={() => {
            posthog.capture(ANALYTICS_EVENTS.PUBLIC_LIST_CTA_CLICKED, {
              [ANALYTICS_PROPS.CTA]: PUBLIC_LIST_CTA.SUBSCRIBE,
              [ANALYTICS_PROPS.CREATOR_USERNAME]: username,
              [ANALYTICS_PROPS.SOURCE]: source,
            });
            window.open(getAppUrl, "_blank", "noopener,noreferrer");
          }}
          className="whitespace-nowrap"
        >
          Subscribe
        </Button>
      </div>
    </div>
  );
}
